export const toMoney = (n: unknown) => {
  const num = typeof n === "string" ? Number(n) : n;
  return typeof num === "number" && Number.isFinite(num) ? Math.round(num) : 0;
};
